import BaseService from "../../BaseService";

export default class PeriodeMonitoringService extends BaseService {

  constructor() {
    super('monitoring/periode');
  }

}
